//@ts-nocheck
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { User } from '../../store/models/User';
import { Page, TLCode, ActionCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import { toJS } from 'mobx';
import VerticalForm from '../common/form/VerticalForm';
import { CheckboxInputFormField, TextInputFormField } from '../common/form';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Form } from 'react-final-form';
import LanguageFormField from '../common/form/LanguageFormField';
import { Button, Intent, MenuItem, FormGroup, Tooltip, Position } from '@blueprintjs/core';
import { Link } from 'react-router-dom';
import { TranslatedMessage } from '../common/translation';
import { IconNames } from '@blueprintjs/icons';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import styled from '@emotion/styled';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import { AuthenticationStore, ApplicationStore, SecretariatStore, RoleStore, PharmacyStore } from '../../store';
import { Role } from '../../store/models';
import SecretariatFormField from '../common/form/SecretariatFormField';
import { PharmacyFormField } from '../common/form';
import { IItemRendererProps, MultiSelect } from '@blueprintjs/select';
import UnauthorizedPage from '../unAuthorized/unAuthorizedPage';

const Container = styled.div`
  display: flex;
  width: 70%;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  & button {
    margin-left: 5px;
  }
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

interface UserFormProps extends WithTranslateProps {
  user?: Instance<typeof User>;
  save: (data: any) => void;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  RoleStore?: Instance<typeof RoleStore>;
}

interface UserFormState {
  loading: boolean;
  userRoles: Array<Instance<typeof Role>>;
}

@inject('AuthenticationStore', 'ApplicationStore', 'RoleStore', 'SecretariatStore', 'PharmacyStore')
@observer
class UserForm extends React.Component<UserFormProps, UserFormState> {
  constructor(props: UserFormProps) {
    super(props);
    this.state = {
      loading: false,
      userRoles: this.props.user !== undefined ? this.props.user.roles : [],
    };
  }

  async componentDidMount() {
    await Promise.all([
      this.props.SecretariatStore!.checkListLoaded(),
      this.props.RoleStore!.getRoles(),
      this.props.PharmacyStore!.checkListLoaded(),
    ]);
  }

  private impersonate = () => {
    const { AuthenticationStore, user } = this.props;
    AuthenticationStore!.impersonate(user!.userName);
  };

  canEditUser = () => {
    return (
      this.props.AuthenticationStore!.isSuperAdmin ||
      (this.props.user !== undefined &&
        this.props.AuthenticationStore!.isSecretariat &&
        this.props.AuthenticationStore!.secretariatId === this.props.user!.secretaryId) ||
      this.props.user === undefined
    );
  };

  goBack = () => {
    window.history.back();
  };

  private rolesItemRenderer = (item: Instance<typeof Role>, { handleClick, modifiers }: IItemRendererProps) => {
    if (!modifiers.matchesPredicate) return null;
    return <MenuItem active={modifiers.active} key={item.roleId} onClick={handleClick} text={item.name} />;
  };

  private onRoleSelected = (change: (name: string, value: any) => void) => (item: Instance<typeof Role>) => {
    const newRoles = [...this.state.userRoles, item];
    this.setState({ userRoles: newRoles });
    change('roles', newRoles);
  };

  private onRoleRemoved = (change: (name: string, value: any) => void) => (value: string, index: number) => {
    const newRoles = this.state.userRoles.filter((elem) => elem.name !== value);
    this.setState({ userRoles: newRoles });
    change('roles', newRoles);
    const isValuePharmacyUserCode = value === ActionCode.PHARMACY_USER_CODE;
    if (isValuePharmacyUserCode) change('pharmacyUserId', undefined);

    const isValueSecretariatUserCode = value === ActionCode.SECRETARY_USER_CODE;
    if (isValueSecretariatUserCode) change('secretariatUserId', undefined);
  };

  private isRolesIntegrityVerified = () => {
    const isPharmacyUser = this.state.userRoles.find((ur) => ur.name === ActionCode.PHARMACY_USER_CODE) !== undefined;
    const isSecretariatUser =
      this.state.userRoles.find((ur) => ur.name === ActionCode.SECRETARY_USER_CODE) !== undefined;
    const isPharmamoveUser =
      this.state.userRoles.find((ur) => ur.name === ActionCode.PHARMAMOVE_USER_CODE) !== undefined;
    const isAdminUser = this.state.userRoles.find((ur) => ur.name === ActionCode.ADMIN_CODE) !== undefined;
    const isSuperAdmin = this.state.userRoles.find((ur) => ur.name === ActionCode.SUPER_ADMIN_CODE) !== undefined;
    const isPubliGardeUser =
      this.state.userRoles.find((ur) => ur.name === ActionCode.PUBLIGARDE_USER_CODE) !== undefined;

    if ((isPharmacyUser || isPharmamoveUser || isSecretariatUser || isPubliGardeUser) && isSuperAdmin) return false;
    if ((isPharmacyUser || isPharmamoveUser || isPubliGardeUser) && isAdminUser) return false;
    if (isPharmacyUser && isSecretariatUser) return false;
    return true;
  };

  private hasAccessToUserForm = () => {
    if (
      !this.props.AuthenticationStore!.isSuperAdmin &&
      this.props.user !== undefined &&
      this.props.user!.roles.find((ur) => ur.name === ActionCode.SUPER_ADMIN_CODE || ur.name === ActionCode.ADMIN_CODE)
    )
      return false;
    return true;
  };

  public render() {
    const { user, translate, save } = this.props;
    const roles = this.props.RoleStore!.dataList.filter(
      (r) =>
        this.props.AuthenticationStore!.isSuperAdmin ||
        ![ActionCode.SUPER_ADMIN_CODE, ActionCode.ADMIN_CODE].find((rc) => rc === r.name),
    );
    const secretariatList = this.props.SecretariatStore!.dataList;
    const pharmacyList = this.props.PharmacyStore!.dataList;

    return this.hasAccessToUserForm() ? (
      <Form
        initialValues={toJS(user) || {}}
        keepDirtyOnReinitialize
        onSubmit={(data: any) => {
          data.roles = this.state.userRoles;
          if (data.isActive === undefined) data.isActive = false;
          save(data);
        }}
        render={({ handleSubmit, form, hasValidationErrors, dirty, values, change }) => {
          return (
            <form onSubmit={handleSubmit}>
              <LeaveRouteDirtyWrapper blockChange={dirty} />
              <Container>
                <VerticalForm labelWidth={175}>
                  <TextInputFormField
                    name="firstName"
                    label={TLCode.Firstname}
                    inline={true}
                    fill={true}
                    required={true}
                  />
                  <TextInputFormField
                    name="lastName"
                    label={TLCode.Lastname}
                    inline={true}
                    fill={true}
                    required={true}
                  />
                  <DivLine>
                    <DivColumn style={{ width: '500px' }}>
                      <TextInputFormField
                        name="userName"
                        label={TLCode.Username}
                        inline={true}
                        fill={true}
                        required={true}
                      />
                    </DivColumn>
                    <DivColumn style={{ width: '200px' }} />
                  </DivLine>
                  <DivLine>
                    <DivColumn style={{ width: '500px' }}>
                      <TextInputFormField name="email" label={TLCode.Email} inline={true} fill={true} required={true} />
                    </DivColumn>
                    {user != null && (
                      <DivColumn style={{ width: '300px' }}>
                        <a href={'mailto:' + user!.email + '?subject=Pharmagarde&from=garde@uphoc.be'}>{user!.email}</a>
                      </DivColumn>
                    )}
                  </DivLine>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
                    <DivColumn style={{ width: 'auto' }}>
                      <PharmacyFormField
                        label={TLCode.PHARMACY}
                        name="pharmacyUserId"
                        pharmacyList={pharmacyList}
                        disabled={values.secretariatUserId !== undefined}
                        allowEmpty
                        isClearable
                        disabled={
                          values.roles === undefined ||
                          (values.roles !== undefined &&
                            !values.roles.find((ur) => ur.name === ActionCode.PHARMACY_USER_CODE))
                        }
                      />
                    </DivColumn>
                    {(this.props.AuthenticationStore!.isSuperAdmin || this.props.AuthenticationStore!.isAdmin) &&
                      values.pharmacyUserId !== undefined && (
                        <DivColumn style={{ width: 'auto' }}>
                          <Tooltip
                            content={translate(TLCode.USER_Goto_Pharmacy)}
                            position={Position.BOTTOM}
                            hoverOpenDelay={500}
                          >
                            <Button
                              icon="home"
                              onClick={() =>
                                this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${values.pharmacyUserId}`)
                              }
                            />
                          </Tooltip>
                        </DivColumn>
                      )}
                  </div>
                  {values.roles !== undefined &&
                  ((values.roles.find((ur) => ur.name === ActionCode.PHARMACY_USER_CODE) && !values.pharmacyUserId) ||
                    (!values.roles.find((ur) => ur.name === ActionCode.PHARMACY_USER_CODE) &&
                      values.pharmacyUserId)) ? (
                    <>
                      <DivLine>
                        <span style={{ color: 'red' }}>{translate(TLCode.USER_Warning_Select_Pharmacy)}</span>
                      </DivLine>
                      <br />
                    </>
                  ) : null}
                  <SecretariatFormField
                    label={TLCode.SECRETARIAT}
                    name="secretariatUserId"
                    secretariatList={secretariatList}
                    disabled={!this.props.AuthenticationStore!.isSuperAdmin || values.pharmacyUserId !== undefined}
                    allowEmpty
                    isClearable
                    disabled={
                      values.roles === undefined ||
                      (values.roles !== undefined &&
                        !values.roles.find((ur) => ur.name === ActionCode.SECRETARY_USER_CODE))
                    }
                  />
                  {values.roles !== undefined &&
                  ((values.roles.find((ur) => ur.name === ActionCode.SECRETARY_USER_CODE) &&
                    !values.secretariatUserId) ||
                    (!values.roles.find((ur) => ur.name === ActionCode.SECRETARY_USER_CODE) &&
                      values.secretariatUserId)) ? (
                    <>
                      <DivLine>
                        <span style={{ color: 'red' }}>{translate(TLCode.USER_Warning_Select_Secretariat)}</span>
                      </DivLine>
                      <br />
                    </>
                  ) : null}
                  <FormGroup
                    label={this.props.translate(TLCode.Roles)}
                    inline={true}
                    disabled={!this.props.AuthenticationStore!.isSuperAdmin}
                  >
                    <MultiSelect
                      itemRenderer={this.rolesItemRenderer}
                      items={roles.filter((r) => this.state.userRoles.find((ur) => ur.name === r.name) === undefined)}
                      onItemSelect={this.onRoleSelected(change)}
                      tagRenderer={(item: Instance<typeof Role>) => item.name}
                      itemPredicate={(query, item) => {
                        return item.name.toLocaleLowerCase().includes(query.toLocaleLowerCase());
                      }}
                      tagInputProps={{
                        onRemove: this.onRoleRemoved(change),
                      }}
                      selectedItems={this.state.userRoles}
                      resetOnSelect
                      placeholder="Select Roles to link"
                    />
                  </FormGroup>
                  {!this.isRolesIntegrityVerified() ? (
                    <>
                      <DivLine>
                        <span style={{ color: 'red' }}>{translate(TLCode.USER_WarningInvalidRoles)}</span>
                      </DivLine>
                      <br />
                    </>
                  ) : (
                    <></>
                  )}
                  <LanguageFormField name="languageCode" required={true} />
                  <SimpleTextFormContent label={TLCode.IS_ACTIVE} small={false}>
                    <CheckboxInputFormField name="isActive" inline={true} />
                  </SimpleTextFormContent>
                </VerticalForm>
                <ButtonsContainer>
                  <Button onClick={this.goBack}>
                    <TranslatedMessage id={TLCode.Back} />
                  </Button>
                  <Button
                    type={'submit'}
                    text={translate(TLCode.GENERAL_Save)}
                    icon={IconNames.FLOPPY_DISK}
                    intent={Intent.PRIMARY}
                    disabled={
                      hasValidationErrors ||
                      (!dirty &&
                        this.props.user !== undefined &&
                        this.props.user!.roles.every((r) => this.state.userRoles.find((ur) => ur.name === r.name)) &&
                        this.state.userRoles.every((ur) => this.props.user!.roles.find((r) => r.name === ur.name))) ||
                      !this.canEditUser() ||
                      !this.isRolesIntegrityVerified() ||
                      (values.roles !== undefined &&
                        ((values.roles.find((ur) => ur.name === ActionCode.PHARMACY_USER_CODE) &&
                          !values.pharmacyUserId) ||
                          (!values.roles.find((ur) => ur.name === ActionCode.PHARMACY_USER_CODE) &&
                            values.pharmacyUserId) ||
                          (values.roles.find((ur) => ur.name === ActionCode.SECRETARY_USER_CODE) &&
                            !values.secretariatUserId) ||
                          (values.roles.find((ur) => ur.name === ActionCode.SECRETARY_USER_CODE) &&
                            !values.secretariatUserId)))
                    }
                  />
                  {this.props.AuthenticationStore!.isSuperAdmin && (
                    <Button
                      text={translate(TLCode.USER_Impersonate)}
                      icon={IconNames.PEOPLE}
                      intent={Intent.DANGER}
                      onClick={this.impersonate}
                    />
                  )}
                </ButtonsContainer>
              </Container>
            </form>
          );
        }}
      />
    ) : (
      <UnauthorizedPage />
    );
  }
}

export default withTranslate(UserForm);
